import Decimal from 'decimal.js'
import lang from '@/lang'
import { invoiceStates, cancellationStates } from '@/modules/base/util/constants'
const { invoiceList: { stateLabels } } = lang
const { DRAFT, CANCELLED, PAID, LOCKED, PARTIALLYPAID, DUNNED, OPEN, CREDITED } = invoiceStates
const { IN_PROGRESS } = cancellationStates

const getStateInfo = (state, isOverDue, outstandingAmount, selection = false) => {
  if (state === IN_PROGRESS) {
    return { label: stateLabels.inProgress, color: 'purple' }
  }

  if (isOverDue && state !== DUNNED) {
    return { label: stateLabels.isOverDue, color: 'red' }
  }

  if (state === CREDITED && new Decimal(outstandingAmount ?? 0).gt(0) && !isOverDue) {
    return { label: stateLabels.lockedCreditNote, color: 'lightBlue' }
  }

  if (state === CREDITED && new Decimal(outstandingAmount ?? 0).gt(0)) {
    return { label: stateLabels.partlyPaid, color: 'lightBlue' }
  }

  switch (state) {
    case DRAFT:
      return { label: stateLabels.draft, color: 'darkGrey' }
    case LOCKED:
      if (selection === true) return { label: stateLabels.lockedCreditNote, color: 'blue' }
      return { label: stateLabels.open, color: 'blue' }
    case OPEN:
      return { label: stateLabels.open, color: 'blue' }
    case DUNNED:
      return { label: stateLabels.dunned, color: 'red' }
    case PAID:
      if (selection === true) return { label: stateLabels.paidCreditnote, color: 'blue' }
      return { label: stateLabels.paid, color: 'green' }
    case CREDITED:
      return { label: stateLabels.paidCreditnote, color: 'green' }
    case CANCELLED:
      return { label: stateLabels.canceled, color: 'grey' }
    case PARTIALLYPAID:
      return { label: stateLabels.partlyPaid, color: 'lightBlue' }
    default:
      return { label: stateLabels.open, color: 'blue' }
  }
}

export default getStateInfo
